import React from "react";
import Konva from "konva";
import { Group, Path } from "react-konva";

export const KonvaDateIcon = React.memo((props: Konva.NodeConfig) => {
  return (
    <Group {...props}>
      <Path
        data="M7.46022 14.5758H2.46831C2.07863 14.5758 1.70491 14.421 1.42937 14.1455C1.15382 13.8699 0.999023 13.4962 0.999023 13.1065V4.29082C0.999023 3.90114 1.15382 3.52742 1.42937 3.25188C1.70491 2.97633 2.07863 2.82153 2.46831 2.82153H11.284C11.6737 2.82153 12.0474 2.97633 12.323 3.25188C12.5985 3.52742 12.7533 3.90114 12.7533 4.29082V7.2294"
        stroke="#7F869B"
        strokeWidth={1.2}
        lineCap="round"
        lineJoin="round"
      />
      <Path
        data="M9.08177 12.3712C9.08177 13.1506 9.39137 13.898 9.94246 14.4491C10.4936 15.0002 11.241 15.3098 12.0203 15.3098C12.7997 15.3098 13.5471 15.0002 14.0982 14.4491C14.6493 13.898 14.9589 13.1506 14.9589 12.3712C14.9589 11.5918 14.6493 10.8444 14.0982 10.2933C13.5471 9.74222 12.7997 9.43262 12.0203 9.43262C11.241 9.43262 10.4936 9.74222 9.94246 10.2933C9.39137 10.8444 9.08177 11.5918 9.08177 12.3712Z"
        stroke="#7F869B"
        strokeWidth={1.2}
        lineCap="round"
        lineJoin="round"
      />
      <Path data="M9.81375 1.34985V4.28843" stroke="#7F869B" strokeWidth={1.2} lineCap="round" lineJoin="round" />
      <Path data="M3.93855 1.34985V4.28843" stroke="#7F869B" strokeWidth={1.2} lineCap="round" lineJoin="round" />
      <Path data="M0.999023 7.2251H12.7533" stroke="#7F869B" strokeWidth={1.2} lineCap="round" lineJoin="round" />
      <Path
        data="M12.0213 11.2644V12.3693L12.7559 13.104"
        stroke="#7F869B"
        strokeWidth={1.2}
        lineCap="round"
        lineJoin="round"
      />
    </Group>
  );
});

KonvaDateIcon.displayName = "KonvaDateIcon";
